import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type LoadingSource = 'http' | 'route';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private httpCounter = 0;
  private routeCounter = 0;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private endTimeout: any = null;

  isLoading$ = this.isLoadingSubject.asObservable();

  isRouteLoading(): boolean {
    return this.routeCounter > 0;
  }

  start(source: LoadingSource): void {
    // Clear any pending end timeout
    if (this.endTimeout) {
      clearTimeout(this.endTimeout);
      this.endTimeout = null;
    }

    if (source === 'http') {
      this.httpCounter++;
    } else {
      this.routeCounter++;
    }
    this.emit();
  }

  end(source: LoadingSource): void {
    if (source === 'http') {
      this.httpCounter = Math.max(0, this.httpCounter - 1);
    } else {
      this.routeCounter = Math.max(0, this.routeCounter - 1);
    }

    // Add a small delay before hiding the loading indicator
    // This ensures it's visible for at least a brief moment
    if (this.endTimeout) {
      clearTimeout(this.endTimeout);
    }

    this.endTimeout = setTimeout(() => {
      this.emit();
      this.endTimeout = null;
    }, 300); // 300ms minimum display time
  }

  private emit(): void {
    const isLoading = (this.httpCounter + this.routeCounter) > 0;
    this.isLoadingSubject.next(isLoading);
  }
}


